import { API } from "src/constants";

import { Http } from "../http";

export const sendFallbackMessage = (
  errorMessage: string,
  url: string,
  stack: string
) =>
  Http.post(`${API}/fallback-logs`, {
    text: errorMessage,
    url: url,
    stacktrace: stack,
    password: "nvj13Da@#sa",
  });
